<div class="vc-details-side-panel">
    <ng-content select="[detailsSidePanelTop]"></ng-content>
    @if (showCreatedOn) {
        <ng-container
            [ngTemplateOutlet]="detailsTemplate"
            [ngTemplateOutletContext]="{
                $implicit: {
                    label: createdOnText,
                    value: (createdOn | date: dateFormat) ?? '—',
                },
            }"></ng-container>
    }

    @if (showCreatedBy) {
        <ng-container
            [ngTemplateOutlet]="detailsTemplate"
            [ngTemplateOutletContext]="{
                $implicit: {
                    label: createdByText,
                    value: createdBy ?? '—',
                },
            }"></ng-container>
    }

    @if (showLastUpdatedOn) {
        <ng-container
            [ngTemplateOutlet]="detailsTemplate"
            [ngTemplateOutletContext]="{
                $implicit: {
                    label: lastUpdatedOnText,
                    value: (lastUpdatedOn | date: dateFormat) ?? '—',
                },
            }"></ng-container>
    }

    @if (showLastUpdatedBy) {
        <ng-container
            [ngTemplateOutlet]="detailsTemplate"
            [ngTemplateOutletContext]="{
                $implicit: {
                    label: lastUpdatedByText,
                    value: lastUpdatedBy ?? '—',
                },
            }"></ng-container>
    }

    <ng-content select="[detailsSidePanelBottom]"></ng-content>
</div>

<ng-template #detailsTemplate let-value>
    <vc-details-side-panel-template [value]="value.value" [label]="value.label"></vc-details-side-panel-template>
</ng-template>
